import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Helper } from '../../utils/helper';

@Component({
  selector: 'app-qrcode-modal',
  templateUrl: './qrcode-modal.component.html',
  styleUrls: ['./qrcode-modal.component.css'],
})
export class QRCodeModalComponent implements OnInit {
  qrcodeData = "";
  currency = "MYR";
  amount="0.00";

  public onClose: Subject<any>;
  constructor(
    public bsModalRef: BsModalRef) {}

  ngOnInit() {
    this.onClose = new Subject();
  }

  onHide() {
    this.onClose.next({ result: false });
    this.bsModalRef.hide();
  }

  refreshPage(){
    this.onClose.next({ result: true });
    this.bsModalRef.hide();
  }

}
